<template>
  <div id="appLoading" v-if="loading">
    <div id="appLoadingWrapper">
      <v-progress-circular
        :size="50"
        :width="5"
        :indeterminate="rotate"
        :value="!rotate ? value : ''"
        :color="color"
      >
      </v-progress-circular>
      <span>{{ !rotate ? value + '%' : loadingText + '..' }}</span>
    </div>
  </div>
</template>
<script>

// This is the loading wheel for the app to indicate the data is being loaded to the DOM.
export default {
  name: 'app-loading',
  props: {
    // Defines if the loading wheel is active or not
    loading: {
      type: Boolean,
      default: false
    },
    // Defines the loading text
    loadingText: {
      type: String,
      default: 'Loading'
    },
    // Defines if the loading wheel is rotating or not
    rotate: {
      type: Boolean,
      default: true
    },
    // Defines the color of loading wheel
    color: {
      type: String,
      default: 'teal'
    },
    // Defines the value (%) of loading wheel when it's not rotating
    value: {
      type: Number,
      default: 0
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/AppLoading.vue